// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionPosition: 'left'
	},
	selector: {
		otpTopCartLink: 'a[href="/cart"].site-header__cart'
	}
};

(function () {
	BoostPFS.inject(this);
	// Customize style of Suggestion box
	SearchInput.prototype.customizeAutoCompleteResizeMenu = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();

